// ABOUTME: Public native-app configuration (minimum supported build per store).
// Backed by app/api/v1/public_app_config.py.

import { api } from './client'

interface StoreValues {
  ios: string
  android: string
}

export interface AppConfig {
  min_app_version: StoreValues
  update_url: StoreValues
}

export async function fetchAppConfig(): Promise<AppConfig> {
  return (await api.get<AppConfig>('/public/app-config')) as unknown as AppConfig
}
